export type SortDirection = 'asc' | 'desc'

export interface SortState<K extends string> {
    key: K
    direction: SortDirection
}

export const compareValues = (a: unknown, b: unknown): number => {
    if (typeof a === 'number' && typeof b === 'number') return a - b
    return String(a ?? '').localeCompare(String(b ?? ''), 'en', { numeric: true, sensitivity: 'base' })
}

export const sortItems = <T>(items: T[], getter: (item: T) => unknown, direction: SortDirection): T[] => {
    return [...items].sort((first, second) => {
        const result = compareValues(getter(first), getter(second))
        return direction === 'asc' ? result : -result
    })
}

export const toggleSort = <K extends string>(current: SortState<K>, key: K, initial: SortDirection = 'asc'): SortState<K> => {
    if (current.key === key) return { key, direction: current.direction === 'asc' ? 'desc' : 'asc' }
    return { key, direction: initial }
}

export const paginate = <T>(items: T[], page: number, pageSize: number): T[] => {
    return items.slice((page - 1) * pageSize, page * pageSize)
}

export const clampPage = (page: number, total: number, pageSize: number): number => {
    const pages = Math.max(1, Math.ceil(total / pageSize))
    return Math.min(Math.max(1, page), pages)
}
